import React from "react";
import { useMediaQuery } from 'react-responsive';
import WebFooter from './Web';
import MobileFooter from './Mobile';


const Footer = () => {
    const isDesktop = useMediaQuery({ minWidth: 768 }); // 目前PC和平板的尺寸没有做区分
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div>
            {isDesktop && <WebFooter />}
            {isMobile && <MobileFooter />}
        </div>
    );
};

export default Footer;